import { render, staticRenderFns } from "./PresentationEdit.vue?vue&type=template&id=6b91cb43&scoped=true&"
import script from "./PresentationEdit.vue?vue&type=script&lang=ts&"
export * from "./PresentationEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PresentationEdit.vue?vue&type=style&index=0&id=6b91cb43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b91cb43",
  null
  
)

export default component.exports